module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/error/swim-358492151ea23e3acf83ca9fdbe23de1.jpg";